import {useIntl} from 'react-intl';

interface LoadingProps {
    className?: string;
}

const Loading = ({className = ''}: LoadingProps): JSX.Element => {
    const intl = useIntl();

    return (
        <div className={`text-center ${className}`} title='Loading'>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{intl.formatMessage({id: 'LOADING'})}...</span>
            </div>
        </div>
    );
};

export default Loading;
